import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #0F1A2A;
    text-align: center;
    padding: 0 60px;

    @media (max-width: 768px) {
        padding: 0 20px;
    }
`

export const TituloSessao = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    margin: 0 0 60px 0;

    @media (max-width: 768px) {

        font-size: 22px;
        line-height: 32px;
        margin: 0 0 45px 0;

        br {
            display: none;
        }

    }
`

export const BoxDepoimento = styled.div`
    float: left;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 60px;

    @media (max-width: 768px) {
        margin-bottom: 40px;
    }
`

export const BoxDepoimentoFoto = styled.img`
    display: inline-block;
    border: solid 2px #F09C00;
    width: 88px;
    height: 88px;
    border-radius: 100px;
`

export const BoxDepoimentoTexto = styled.span`
    width: 100%;
    color: #fff;
    margin: 20px 0;
    font-size: 20px;
    font-style: italic;
    font-weight: 300;
    line-height: 32px;

    @media (max-width: 768px) {

        margin: 15px 0;
        font-size: 18px;
        line-height: 30px;
        
        br {
            display: none;
        }

    }
`

export const BoxDepoimentoNome = styled.span`
    color: #C98400;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 16px;
`

export const BoxDepoimentoLegenda = styled.span`
    color: #C98400;
    font-size: 14px;
    line-height: 22px;
`
